import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  Divider,
  Box,
  ButtonGroup,
  CardContent,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DialogActions from '@mui/material/DialogActions';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import moment from 'moment';
import Zoom from '@mui/material/Zoom';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import Tooltip from '@mui/material/Tooltip';
import { PropTypes } from 'prop-types';
import { messageActionsSaga } from '../../../../infrastructure/services/message';
import { messageActions } from '../../../../application/actions/message';
//import { comentsActions } from '../../../../application/actions/coments';
import GroupsIcon from '@mui/icons-material/Groups';
import ChatIcon from '@mui/icons-material/Chat';
import AvatarList from '../../molecula/AvatarList/AvatarList';
import GradientCircularLoader from '../../molecula/circularLoader/circularLoader';
import './index.css';
import { TypeNotifications } from '../../organismos/wss/typeNotifications.enum';

function ComentsView({
  show,
  handlerShow,
  cardSelected,
  lassMessageAplication
}) {
  const dispatch = useDispatch();

  const {
    create,
    getById,
    update,
  } = useSelector((store) => store.tk.message);
  const { id: idSesion } = useSelector((store) => store.tk.sesion.user);
  const [comment, setComment] = useState('');
  const [myComents, setMyComents] = useState([]);
  const [myUsers, setMyUsers] = useState([]);
  const [showUsers, setShowUsers] = useState(false);

  const handlreGetComents = () => {
     dispatch(messageActionsSaga.getById({ id: cardSelected.id }));
  };

  useEffect(()=>{
    getById.connection && dispatch(messageActionsSaga.getAll())
  },[getById.connection])

  useEffect(() => {
    console.log(cardSelected);
    //if (show && cardSelected.id) {
      dispatch(messageActions.getByIdReset());
      handlreGetComents();
    //}
  }, []);

  const capitalizarPrimeraLetra = (str) => {
    if (str === null || str === '') {
      return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handlerSendComent = () => {
    const data = { caseId: cardSelected.id, message:comment };
    dispatch(messageActionsSaga.create({ data }));
  };



  useEffect(() => {
    if (create.result) {
      setComment('');
      //handlreGetComents();
    }
  }, [create]);

  useEffect(() => {
    if (getById.data.messages.length > 0) {
      setMyComents(getById.data.messages);
    }else{
      //setMyComents([])
    }
    if (getById.data.users.length > 0) {
      setMyUsers(getById.data.users);
    }else{
      //setMyUsers([])
    }
  }, [getById.data]);

  const validateUser = (flagIn) => {
    const flag = idSesion;
    let validate = false;
    if (flag === flagIn) {
      validate = true;
    }
    return validate;
  };

  useEffect(()=>{
      if( lassMessageAplication && lassMessageAplication.type === TypeNotifications.GETMESSAGES){ handlreGetComents() }
    },[lassMessageAplication])

 



  const handlreExit = () => {
    dispatch(messageActionsSaga.getAll())
    setMyComents([]);
    setMyUsers([]);
    setShowUsers(false)
    handlerShow(false);
  };

  const inputTex = () => {
    const componet = (
      <DialogActions sx={{ backgroundColor:  '#FFF', mb: 0, p: 1 }}>
        <FormControl sx={{ m:  1 }} fullWidth>
          <OutlinedInput
            sx={{
              backgroundColor: '#FFF',
              borderRadius: 2,
              boxShadow: '0px 0px 27px -10px rgba(0,0,0,0.2)',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#FFF',
              },
              '&:hover > .MuiOutlinedInput-notchedOutline': {
                borderColor: '#618c8c',
              },
              '&:select > .MuiOutlinedInput-notchedOutline': {
                borderColor: '#618c8c',
              },
            }}
            type="text"
            placeholder={'Escribe un mensaje nuevo'}
            /* disabled={getById.connection} */
            endAdornment={(
              <InputAdornment position="end">
                
                  <IconButton
                    disabled={update.connection || comment === ''}
                    onClick={() => { handlerSendComent(); }}
                    edge="end"
                  >
                    <SendIcon sx={{ color: '#618c8c' }} />
                  </IconButton>
                
              </InputAdornment>
            )}
            value={comment}
            onChange={(e) => { setComment(e.target.value); }}
          />
        </FormControl>
      </DialogActions>
    );

    return componet;
  };

  const mapControlMyComents = () => {
    const myComentsNew = myComents;

    return myComentsNew;
  };


  const mapAvatarList = (data) => {
    const map = []
    data.map(x => map.push({
      id: x.id,
      title: `${x.userFullName}`,
      subTitle: '',
      details: x.role
    }));
    return map;

  }

  const display = () => {
    const displayContend = (
      <>

       
          <>
            <DialogTitle sx={{ lineHeight: 1.2, backgroundColor: '#FFF', boxShadow: 'inset  0px 0px 27px -10px rgba(0,0,0,0.1)' }}>
              <Typography sx={{ pb: 0, mb: 0, color: '#000' }} variant="h5" component="p">
                { cardSelected.title }
              </Typography>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={()=>setShowUsers(!showUsers)}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
               {!showUsers ? <GroupsIcon /> : <ChatIcon/> }
            </IconButton>
          </>
        
        
        {myComents.length === 0  && getById.connection && <Box sx={{ backgroundColor: '#ffffff99', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, zIndex: 100, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><GradientCircularLoader /></Box>}

        <DialogContent
          sx={{
            pl: 0,
            pr: 0,
            backgroundColor:'#ededed',
            rotate: '180deg',
            direction: 'rtl',
            boxShadow: 'inset  0px 0px 27px -10px rgba(0,0,0,0.1)',
            mb: 0,
            height: '100%',
            minHeight:200
          }}
        >
          <Box sx={{
            pl: 3, pr:  3, rotate:  '180deg',
          }}
          >
            

            <CardContent sx={{
              m: 0, p: 0, mt: -3, overflow: 'hidden',
            }}
            > 


              {showUsers && (
                <Paper sx={{
                  margin:{xs:0, sm:3},
                  borderRadius: 2,
                  direction: 'ltr',
                  overflow:'hidden'
                }} > 
                <AvatarList items={mapAvatarList(myUsers)} />
                </Paper>
                
              ) }

              {!showUsers  && ( myComents && myComents.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex-inline',
                    mb: 2,
                    direction: 'rtl',
                  }}
                >
                  <Paper sx={{
                    p: 1.5,
                    borderRadius: 2,
                    borderBottomRightRadius:  0,
                    width: 'fit-content',
                    backgroundColor:  '#afbcbc',
                    direction: 'ltr',
                  }}
                  >
                    <Typography sx={{
                      fontSize: 15, color: '#000', fontWeight: 100,
                    }}
                    >
                      {getById.connection ? ' ':'No existen comentarios'}
                    </Typography>
                  </Paper>

                </Box>
              ) : (
                <>
                  { mapControlMyComents().map((item, index) => (

                    <Box
                      sx={{
                        display: 'flex-inline',
                        mb: 2,
                        direction: validateUser(item.messageUserId) ? 'rtl' : 'ltr',
                      }}
                    >
                      <Typography sx={{
                        fontSize: 12, color: '#6c6c6c', fontWeight: 100, mb:  0.5,
                      }}
                      >
                        {item.userMessanger}
                        {'   -   '}
                        {moment(item.dateMessanger).format('YYYY-MM-DD HH:MM a')}
                      </Typography>

                      <Tooltip
                        TransitionComponent={Zoom}
                        placement="top-end"
                        componentsProps={{
                          tooltip: {

                            sx: {
                              bgcolor:  '#FFF',
                              '& .MuiTooltip-arrow': {
                                color: 'common.black',
                              },
                              mt: 10,
                            },
                          },
                        }}
                      >
                        <Paper
                          elevation={ 1}
                          sx={{
                            p: 1.5,
                            pl:  1.5,
                            pr: 1.5,
                            borderRadius:  2,
                            borderTopLeftRadius: validateUser(item.messageUserId) ? 10 : 0,
                            borderTopRightRadius: validateUser(item.messageUserId) ? 0 : 10,
                            width: 'fit-content',
                            backgroundColor: validateUser(item.messageUserId) ?  '#ddf1d8' : !item.readStatus ? '#add3a3':'#FFFFFF',
                          }}
                        >
                          <>
                            <Typography sx={{
                              fontSize: 15, color: validateUser(item.messageUserId) ? '#000' : !item.readStatus ? '#000000':'#6c6c6c' , fontWeight: 100,
                            }}
                            >
                              {capitalizarPrimeraLetra(item.message)}
                            </Typography>
                            
                          </>

                          { }

                        </Paper>
                      </Tooltip>
                    </Box>
                  ))}
                </>
              ))}
            </CardContent>
          </Box>
        </DialogContent>
        {inputTex()}
      </>
    );

    return displayContend;
  };

  return (
      <Dialog
        disableEscapeKeyDown
        open={show}
        onClose={() => handlreExit()}
        fullWidth="sm"
        maxWidth="sm"
      >
        {display()}
      </Dialog>
  );
}

ComentsView.propTypes = {
  show: PropTypes.bool.isRequired,
  handlerShow: PropTypes.number.isRequired,
  cardSelected: PropTypes.number.isRequired
};

export default ComentsView;
